import * as firebase from 'firebase/app'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from './Routes'

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyB0Ow5G5kl7oqYBEAj38cUPKVj7DvPUK4E',
  authDomain: 'invoicez-e2acf.firebaseapp.com',
  databaseURL: 'https://invoicez-e2acf.firebaseio.com',
  projectId: 'invoicez-e2acf',
  storageBucket: 'invoicez-e2acf.appspot.com',
  messagingSenderId: '347648599535',
}

firebase.initializeApp(config)

ReactDOM.render(
  <Router>
    <Routes />
  </Router>,
  document.getElementById('root') as HTMLElement
)



// WEBPACK FOOTER //
// ./src/index.tsx